import React                      from 'react'
import { autorun }                from 'mobx'
import { Observer }               from 'mobx-react'
import { Button
       , Empty
       , InputNumber
       , Layout
       , Modal
       , Table }                  from 'antd'

import { ERROR_CODE
       , TEXT
       , tr }                     from '../00_assets'
import { numerically_asc }        from '../01_core'
import { API
       , kde_api_pseudo_job_t }   from '../02_api'
import { BulkJobsEditor
       , create_bulk_jobs_editor_model } from './04_screen_key_mastering_bulk_jobs_editor'
import { FACTORY
       , MApp }                   from '../09_model_app'
import { Biting
       , ModalPrompt
       , TableState
       , Toolbar }                from '../10_ui'


import { MKeyMastering }           from './01_screen_key_mastering_model'



export const PseudoTasks: React.FC = () =>
<Observer render={ ( ) =>
{
  const model     = MKeyMastering.instance( )
      , num_tasks = model.selected_tasks.length
      , on_launch = ( ) =>
        {
           const num_keys   = model.total_num_keys( )
               , jobs_model = create_bulk_jobs_editor_model( )
               , modal      = ModalPrompt( tr( TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS, { num: num_keys } )
                      , <BulkJobsEditor form={ jobs_model } />
                      , async ( ) =>
                        {
                          const machine  = jobs_model.fields( )
                              , mastering = model.masterings.data.find( tra => tra.id === model.selected_mastering )
                              , client   = { client: { id: mastering? mastering.client.id : 0 } }
                              , payload  = model.bulk( ).map( pl => ({ ...machine, ...pl, ...client }) )
                              , app      = MApp( ) ;
                          
                          stop_obs( ) ;

                          return API.JOBS_BULK( app.user!.workgroup.cloud.id )
                                    .add!( payload )
                                    .then( res =>
                                    {
                                      if ( (res as any).error.code === ERROR_CODE.NONE )
                                        {
                                           Modal.info( { title: tr( TEXT.KEY_MASTERING_KEYS_CREATED, { num: model.selected_tasks.length } ) } ) ;
                                           FACTORY.JOBS.reset( ) ;
                                           model.reset_selected_tasks( ) ;
                                        }

                                      return res ;
                                    }) ;
                        }
                      , 'warning'
                      , tr( TEXT.KEY_MASTERING_LAUNCH )
                      )
               , stop_obs   = autorun( ( ) =>
                              modal.update( { okButtonProps: { disabled: jobs_model.model.machine.value( ) === '' } } ) ) ;
        }
      , pseudo_tasks = model.pseudo_tasks ;


  return pseudo_tasks === null?
          <Empty className="flex-col w-100 flex-justify-center" description={ tr( TEXT.UI_NO_DATA ) }/>
        : <Layout.Content className="scrollable">
            <Toolbar>
              <div><span style={{fontWeight: 'bold'}}>{ tr( TEXT.UI_CLIENT ) }:</span> { model.client_name }</div>
              <Button
                  className="ml-auto"
                  disabled={ num_tasks === 0 }
                  onClick={ on_launch }
                  type="primary"
              >
                {
                  num_tasks === 0?
                    tr( TEXT.KEY_MASTERING_LAUNCH )
                  : tr( TEXT.KEY_MASTERING_LAUNCH_N, { num: num_tasks } )
                }
              </Button>
            </Toolbar>
            <TasksTable
              // loading={ src.loading }
              tasks={ pseudo_tasks.slice( 0 ) }
    //           onDelete={ model.tasks.on_delete }
    //           onEdit={ model.tasks.on_edit }
            />
          </Layout.Content> ;
} }/>


export const TasksTable: React.FC<
   { tasks: kde_api_pseudo_job_t[]
//   , onDelete: ( user: kde_api_machine_t ) => any
//   , onEdit: ( user: kde_api_machine_t, new_values: Partial< kde_api_machine_t > ) => any
//   , loading: boolean
//   , buttonsDisabled: boolean
   } > = ( props ) =>
{
  const table_state = TableState( ) ;

  return <Observer render={ ( ) =>
  {
    const row_key       = ( row: kde_api_pseudo_job_t ) => row.id + ''
        , model         = MKeyMastering.instance( )
        , row_className = ( ) => "on-hover"
        , row_selection = { onChange: (tasks_ids: any[], _rows:any ) => model.selected_tasks = tasks_ids
                          , selectedRowKeys: model.selected_tasks
                          , getCheckboxProps: (record:any) => ({ name: record.name })
                          }
        , columns: any[] = [ { title: tr( TEXT.JOB_NUM_KEYS )
                      , key: 'num_copies'
                      , render: ( row: kde_api_pseudo_job_t ) => <NumKeys row={ row } />
                      }
                    , { title: tr( TEXT.KEY_MODEL )
                      , dataIndex: 'key.model'
                      , ...table_state.sort_col( 'model'
                                               , (row: kde_api_pseudo_job_t) => row.key.model )
                      // , render: ( row: kde_api_pseudo_job_t ) =>
                      //     <span>{ row.key.model }</span>
                      }
                    , { title: tr( TEXT.KEY_DATA_SHEET )
                      , dataIndex: 'key.datasheet.id'
                      , ...table_state.sort_col( 'datasheet'
                                               , (row: kde_api_pseudo_job_t) => row.key.datasheet.id
                                               , numerically_asc )
                      // , render: ( row: kde_api_pseudo_job_t ) =>
                      //     <span>{ row.key.datasheet.id }</span>
                      }
                    , { title: tr( TEXT.KEY_SERIES )
                      , dataIndex: 'key.series'
                      , ...table_state.sort_col( 'series'
                                               , (row: kde_api_pseudo_job_t) => row.key.series )
                      // , render: ( row: kde_api_pseudo_job_t ) =>
                      //     <span>{ row.key.series }</span>
                      }
                    , { title: tr( TEXT.KEY_CODE )
                      , dataIndex: 'key.code'
                      , ...table_state.sort_col( 'code'
                                               , (row: kde_api_pseudo_job_t) => row.key.code )
                      // , render: ( row: kde_api_pseudo_job_t ) =>
                      //     <span>{ row.key.code }</span>
                      }
                    , { title: tr( TEXT.KEY_BITING )
                      , key: 'bitting'
                      , render: ( row: kde_api_pseudo_job_t ) =>
                          <Biting value={ row.key.biting } />
                      }
                    ] ;


    return <Table
            rowSelection={ row_selection } 
            className="m-3 shadow"
            columns={ columns }
            dataSource={ props.tasks }
            pagination={ false }
            rowKey={ row_key }
            rowClassName={ row_className }
            onChange={ table_state.on_table_change }
          /> ;
  } }/>
}


const NumKeys: React.FC<{ row: kde_api_pseudo_job_t }> = ({row}) =>
{
  const model    = MKeyMastering.instance( )
      , on_change_num_keys = ( job_id: number ) => ( num: number | undefined ) => model.set_num_keys( job_id, num || 0 )
      , render = ( ) =>
    <InputNumber 
        value={ model.get_num_keys( row.id ) }
        min={ 0 }
        onChange={ on_change_num_keys( row.id ) } />

  return <Observer render={ render } /> ;
}
